import React, { useEffect, useState } from "react";

import classNames from "classnames";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from 'primereact/progressspinner';
import { DataTable } from 'primereact/datatable';
import { Column } from "primereact/column";

import { format } from "date-fns";
import { mask, unmask } from "remask";

import { Api } from "../../../../services/api";
import { Button } from "primereact/button";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";

import GeraXLSX from "../../../../utils/GeraXLSX";
import { decodeBase64, showFile } from "../../../../utils/Base64ToPDF";

export const CommunicationInfo = ({ rowInfo, close }) => {
    const {
        usuario_documento,
        usuario_nome,
    } = rowInfo;

    const [communicationData, setCommunicationData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    const [bufferPDF, setBufferPDF] = useState();
    const [downloadPDF, setDownloadPDF] = useState(false);

    useEffect(() => {
        const getComunicationInfo = async () => {
            try {
                setLoading(true)
                const { data } = await Api.get(`/historicoComunicacoes/comunicacao_devedor/${usuario_documento}`)
                setCommunicationData(data)
            } catch (error) {
                console.log(error.response)
            } finally {
                setLoading(false)
            }
        }
        getComunicationInfo()
    }, [])

    // functions
    const sortByField = async (event) => {
        const { sortField, sortOrder } = event;
        let sortedData = [...communicationData];

        setSortField(sortField);
        setSortOrder(sortOrder);

        if (sortField === 'datahora')
            sortedData.sort((a, b) => {
                const da = new Date(a?.datahora || 0).getTime();
                const db = new Date(b?.datahora || 0).getTime();

                if (da === db) return 0;
                return sortOrder * (da < db ? -1 : 1);
            });

        setCommunicationData(sortedData);
    }
    const downloadXLSX = async () => {
        try {
            let relatorioXLSX = communicationData.map(({ tipo, finalidade, contato, datahora }) => {
                return {
                    usuario_nome,
                    usuario_documento: templateDocument(usuario_documento),
                    tipo,
                    finalidade,
                    contato,
                    datahora: format(new Date(datahora), 'dd/MM/yyyy HH:mm')
                }
            })

            const headers = ['CPF/CNPJ', 'Nome', 'Tipo', 'Finalidade', 'Contato', 'Data/hora']
            const fields = ['usuario_documento', 'usuario_nome', 'tipo', 'finalidade', 'contato', 'datahora']
            const parametrosXLSX = {
                data: relatorioXLSX,
                headers: headers,
                fields: fields,
                titulo: `Relatório_de_comunicações_${usuario_nome}-${usuario_documento}_${format(new Date(), 'dd-MM-yyyy')}`
            }

            GeraXLSX(parametrosXLSX);
        } catch (error) {
            console.log(error)
        }
    }

    const exportaPDFBack = async () => {
        let relatorioPDF = communicationData.map(({ tipo, finalidade, contato, datahora }) => {
            return {
                usuario_nome,
                usuario_documento: templateDocument(usuario_documento),
                tipo,
                finalidade,
                contato,
                datahora: sentDateTemplateValidate(datahora)
            }
        });

        const headers = ['CPF/CNPJ', 'Nome', 'Tipo', 'Finalidade', 'Contato', 'Data/hora'];
        const keys = ['usuario_documento', 'usuario_nome', 'tipo', 'finalidade', 'contato', 'datahora'];

        const tipos = []
        for (let i = 0; i < 5; i++)
            tipos.push('texto')
        try {
            setLoading(true)
            const body = {
                headers,
                keys,
                tipos,
                registros: relatorioPDF,
                titulo: `CPF/CNPJ: ${templateDocument(usuario_documento)} 
                | Devedor: ${usuario_nome} 
                | Relatório gerado em ${format(new Date, 'dd/MM/yyyy HH:mm')}`,
            }
            const { data } = await Api.post('relatorio/generico/gerarPdf', body)
            setBufferPDF(decodeBase64(data))
            setDownloadPDF(true)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const sentDateTemplateValidate = (e) => {
        if (e !== '')
            return format(new Date(e), 'dd/MM/yyyy HH:mm');
        return '-';
    };

    const templateDocument = (e) => {
        if (e !== '')
            return mask(unmask(e), ['999.999.999-99', '99.999.999/9999-99']);
        return '-';
    }

    return (
        <div>
            <Dialog
                visible
                header={`Informações de Comunicação`}
                pt={{
                    root: 'w-screen md:w-auto h-auto ',
                    header: classNames('flex items-center justify-between shrink-0',
                        'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
                        'dark:bg-gray-900  dark:text-white/80'),
                    content: ({ state }) => ({
                        className: classNames('overflow-auto w-full h-full text-center',
                            'bg-white text-gray-700 px-6 pb-8 pt-0',
                            'rounded-bl-lg rounded-br-lg',
                            'dark:bg-gray-900 dark:text-white/80 ', {
                            grow: state.maximized
                        })
                    }),
                }}
                onHide={() => close()}
            >
                {loading ?
                    <ProgressSpinner strokeWidth="6" />
                    :
                    <div className="flex flex-col">
                        <section className="flex flex-row">
                            <span className="flex flex-col justify-start w-full text-xl">
                                <h5 className="flex gap-2"><b>Nome: </b>{usuario_nome}</h5>
                                <h5 className="flex gap-2"><b>Documento: </b>{templateDocument(usuario_documento)}</h5>
                                <h5 className="flex gap-2"><b>Total de Mensagens: </b>{communicationData.length}</h5>
                            </span>
                            <span className="flex flex-col justify-start w-fit text-xl gap-2">
                                <Button
                                    severity="success"
                                    icon={<FaFileExcel />}
                                    tooltip="Baixar como XLSX"
                                    tooltipOptions={{ position: 'left' }}
                                    onClick={() => downloadXLSX()} />
                                <Button
                                    severity="danger"
                                    icon={<FaFilePdf />}
                                    tooltip="Baixar como PDF"
                                    tooltipOptions={{ position: 'left' }}
                                    onClick={() => exportaPDFBack()} />
                            </span>
                        </section>
                        <section>
                            <DataTable
                                value={communicationData}
                                sortMode="single"

                                onSort={sortByField}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                removableSort

                                scrollHeight="300px"
                                size="small"
                                paginator
                                rowsPerPageOptions={[5, 10, 20]}
                                rows={5}
                            >
                                <Column
                                    style={{ width: '25%' }}
                                    header='Tipo'
                                    field="tipo"
                                />
                                <Column
                                    style={{ width: '25%' }}
                                    header='Finalidade'
                                    field="finalidade"
                                />
                                <Column
                                    style={{ width: '25%' }}
                                    header='Contato'
                                    field="contato"
                                />
                                <Column
                                    style={{ width: '25%' }}
                                    header='Data/Hora'
                                    field="datahora"
                                    body={rowData => sentDateTemplateValidate(rowData.datahora)}
                                    sortable
                                />
                            </DataTable>
                        </section>
                    </div>
                }
            </Dialog>
            <Dialog
                transitionOptions={null}
                draggable={false}
                visible={downloadPDF}
                onHide={() => setDownloadPDF(false)}
                pt={{
                    root: 'w-screen md:w-auto h-auto ',
                    header: classNames('flex items-center justify-between shrink-0',
                        'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
                        'dark:bg-gray-900  dark:text-white/80'),
                    content: ({ state }) => ({
                        className: classNames('overflow-auto w-full h-full text-center',
                            'bg-white text-gray-700 px-6 pb-8 pt-0',
                            'rounded-bl-lg rounded-br-lg',
                            'dark:bg-gray-900 dark:text-white/80 ', {
                            grow: state.maximized
                        })
                    }),
                }}
                header="Arquivo pronto"
            >
                <Button
                    label="Baixar"
                    type="button"
                    severity="success"
                    icon="pi pi-download"
                    onClick={() => {
                        setDownloadPDF(false);
                        showFile(bufferPDF, `Relatório_de_comunicações_${usuario_nome}-${usuario_documento}_${format(new Date(), 'dd-MM-yyyy')}`)
                    }
                    }
                    style={{ width: 150, height: 60, fontSize: 18 }}
                />
            </Dialog>
        </div>
    )
}